/* unplugin-vue-components disabled */import { render } from "./recommendCom.vue?vue&type=template&id=1179bbae&scoped=true"
import script from "./recommendCom.vue?vue&type=script&lang=js"
export * from "./recommendCom.vue?vue&type=script&lang=js"

import "./recommendCom.vue?vue&type=style&index=0&id=1179bbae&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.15_webpack@5.89.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1179bbae"]])

export default __exports__